import styles from './PricingTableGroup.scss';

import cx from 'classnames';
import React, { useState } from 'react';

import { Image } from 'src/components/Image/Image';
import { TextV2 } from 'src/components/TextV2/TextV2';
import upArrowIcon from './up-arrow.svg';

interface PricingTableGroupProps {
  title?: string;
  colSpanCount?: number;
  id?: string;
}

export const PricingTableGroup: React.FC<PricingTableGroupProps> = ({ children, title, colSpanCount = 0, id }) => {
  const [open, setOpen] = useState(true);

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <tbody>
      <tr className={styles.row} onClick={toggleOpen}>
        <th colSpan={colSpanCount + 1} scope="colgroup" id={`category-${id}`}>
          <TextV2 value={title} variant="body-bold" data-test="title" className={styles.rowHeading} />
          <button
            className={styles.rowButton}
            aria-label={`${open ? 'Collapse' : 'Expand'} ${title}`}
            aria-expanded={open ? true : false}
            id={`toggle-${id}`}
          >
            <Image
              src={upArrowIcon}
              className={cx(styles.rowIcon, { [styles.rowIconReversed]: !open })}
              alt=""
              isLazyLoad={false}
            />
          </button>
        </th>
      </tr>
      {open && children}
    </tbody>
  );
};
